import type { IconSvgObject } from './types';

const NoteIcon: IconSvgObject = [
  ["path", { d: "M13.0004 7.00002L17.5004 8.00002M12.0004 11L14.5004 11.5M9.9075 3.42761L7.06957 13.8414C6.79556 14.8469 7.35424 15.8921 8.33561 16.21L16.6612 18.9069C17.7066 19.2455 18.8193 18.6298 19.1022 17.5562L21.9347 6.80377C22.2056 5.77542 21.6093 4.71771 20.5969 4.43075L12.2767 2.0725C11.2525 1.78222 10.1903 2.38976 9.9075 3.42761Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.44717 7H4.0173C2.69927 7 1.73566 8.22458 2.06501 9.48101L4.95617 20.5106C5.22936 21.5528 6.29651 22.1908 7.36183 21.9488L12 20.895", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default NoteIcon;
